import { Grid, Typography } from '@mui/material';

import { FirstPolicy } from './FirstPolicy';
import { SecondPolicy } from './SecondPolicy';
import { ThirdPolicy } from './ThirdPolicy';

export const Policy = () => {
    return (
        <Grid container direction="column" spacing={2} my={1} px={2} pb={2}>
            <Grid item container justifyContent="center">
                <Typography variant="h6">ポリシー</Typography>
            </Grid>
            <Grid item>
                <FirstPolicy />
            </Grid>
            <Grid item>
                <SecondPolicy />
            </Grid>
            <Grid item>
                <ThirdPolicy />
            </Grid>
        </Grid>
    )
}

